module.exports = __webpack_public_path__ + "assets/images/hanxin.9ef2187dcabb17c9dca74c7a16345d45.png";